import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Card,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import { getSubscriptionById } from "../../actions/subscriptionAction";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { useParams, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import moment from "moment-timezone";

export default function ViewSubscriptionDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [subscriptionData, setSubscriptionData] = useState({});
  const [userData, setUserData] = useState({});
  const [allSubscriptions, setAllSubscriptions] = useState([]);
  const [packagePricing, setPackagePricing] = useState(null);
  const [loader, setLoader] = useState(true);

  const convertDate = (dateString) => {
    if (!dateString) return "N/A";
    const utcTime = moment.utc(dateString);
    const chicagoTime = utcTime.tz("America/Chicago", false);
    return chicagoTime.format("MM-DD-YYYY, h:mm A");
  };

  const getAgeFromDate = (dateString) => {
    if (!dateString) return "N/A";
    const today = new Date();
    const birthDate = new Date(dateString);
    const ageDiff = today.getTime() - birthDate.getTime();
    const ageDate = new Date(ageDiff);
    const age = Math.abs(ageDate.getUTCFullYear() - 1970);
    return age;
  };

  const getSubscription = async () => {
    setLoader(true);
    try {
      let res = await getSubscriptionById(id);
      if (res?.data?.success) {
        setSubscriptionData(res.data.data.subscription || {});
        setUserData(res.data.data.user || {});
        setAllSubscriptions(res.data.data.allSubscriptions || []);
        setPackagePricing(res.data.data.packagePricing || null);
      }
    } catch (error) {
      console.error("Error fetching subscription:", error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getSubscription();
  }, [id]);

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-5">
          <Container fluid>
            <Row>
              <Col md="12">
                <div className="d-flex align-items-center mb-4">
                  <Button
                    variant="link"
                    onClick={() => navigate("/subscription")}
                    className="p-0 me-3"
                  >
                    <IoArrowBack size={24} />
                  </Button>
                  <h4 className="mb-0">Subscription Details</h4>
                </div>

                {/* User Information */}
                <Card className="mb-4">
                  <Card.Header>
                    <Card.Title as="h5" className="mb-0">
                      User Information
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    <Table striped className="consultation-table">
                      <tbody>
                        <tr>
                          <th>Name</th>
                          <td>
                            {userData?.firstName || ""} {userData?.lastName || ""}
                          </td>
                          <th>Email</th>
                          <td>{userData?.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Phone</th>
                          <td>{userData?.phone || "N/A"}</td>
                          <th>Date of Birth</th>
                          <td>
                            {userData?.dateOfBirth
                              ? convertDate(userData.dateOfBirth)
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Age</th>
                          <td>
                            {userData?.dateOfBirth
                              ? `${getAgeFromDate(userData.dateOfBirth)} Years`
                              : "N/A"}
                          </td>
                          <th>Gender</th>
                          <td>{userData?.gender || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Address</th>
                          <td>{userData?.address || "N/A"}</td>
                          <th>City</th>
                          <td>{userData?.city || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>State</th>
                          <td>{userData?.state || "N/A"}</td>
                          <th>Zip Code</th>
                          <td>{userData?.zipCode || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Account Created</th>
                          <td>
                            {userData?.createdAt
                              ? convertDate(userData.createdAt)
                              : "N/A"}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>

                {/* All Subscriptions */}
                <Card className="mb-4">
                  <Card.Header>
                    <Card.Title as="h5" className="mb-0">
                      All Subscriptions ({allSubscriptions.length})
                    </Card.Title>
                  </Card.Header>
                  <Card.Body>
                    {allSubscriptions.length > 0 ? (
                      <div className="table-responsive">
                        <Table striped className="consultation-table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Order ID</th>
                              <th>Package</th>
                              <th>Price</th>
                              <th>Status</th>
                              <th>Recurring</th>
                              <th>Payment Status</th>
                              <th>Paid Date</th>

                              {/* <th>Created At</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {allSubscriptions.map((subscription, index) => (
                              <tr key={subscription._id}>
                                <td>{index + 1}</td>
                                <td>
                                  {subscription.package
                                    ? subscription.package
                                        .charAt(0)
                                        .toUpperCase() +
                                      subscription.package.slice(1)
                                    : "N/A"}
                                </td>
                                <td>{subscription.orderId || "N/A"}</td>
                                <td>
                                  ${subscription.price?.toFixed(2) || "0.00"}
                                </td>
                                <td>
                                  {subscription.status === "active" ? (
                                    <label className="label label-success m-0">
                                      Active
                                    </label>
                                  ) : subscription.status === "inactive" ? (
                                    <label className="label label-danger m-0">
                                      Inactive
                                    </label>
                                  ) : (
                                    <label className="label label-warning m-0">
                                      {subscription.status || "N/A"}
                                    </label>
                                  )}
                                </td>
                                
                                <td>
                                  {subscription.isRecurring ? (
                                    <label className="label label-success m-0">
                                      Yes
                                    </label>
                                  ) : (
                                    <label className="label label-secondary m-0">
                                      No
                                    </label>
                                  )}
                                </td>
                               
                                <td>
                                  {subscription.paymentStatus === "paid" ? (
                                    <label className="label label-success m-0">
                                      Paid
                                    </label>
                                  ) : (
                                    <label className="label label-danger m-0">
                                      {subscription.paymentStatus || "Unpaid"}
                                    </label>
                                  )}
                                </td>
                                 <td>
                                  {subscription.paidDate
                                    ? convertDate(subscription.paidDate)
                                    : "N/A"}
                                </td>
                                {/* <td>
                                  {subscription.createdAt
                                    ? convertDate(subscription.createdAt)
                                    : "N/A"}
                                </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <p className="text-center text-muted">
                        No subscriptions found for this user.
                      </p>
                    )}
                  </Card.Body>
                </Card>

                {/* Package Pricing Information */}
                {packagePricing && (
                  <Card className="mb-4">
                    <Card.Header>
                      <Card.Title as="h5" className="mb-0">
                        Package Pricing Information
                      </Card.Title>
                    </Card.Header>
                    <Card.Body>
                      <Table striped className="consultation-table">
                        <tbody>
                          <tr>
                            <th>Package</th>
                            <td>
                              {packagePricing?.package
                                ? packagePricing.package
                                    .charAt(0)
                                    .toUpperCase() +
                                  packagePricing.package.slice(1)
                                : "N/A"}
                            </td>
                            <th>Discount Type</th>
                            <td>
                              {packagePricing?.discountType
                                ? packagePricing.discountType
                                    .charAt(0)
                                    .toUpperCase() +
                                  packagePricing.discountType.slice(1)
                                : "N/A"}
                            </td>
                          </tr>
                          <tr>
                            <th>Discount Value</th>
                            <td>
                              {packagePricing?.discountType === "percentage"
                                ? `${packagePricing.discountPercentage}%`
                                : packagePricing?.discountType === "fixed"
                                ? `$${packagePricing.discountPrice}`
                                : "N/A"}
                            </td>
                            <th>Status</th>
                            <td>
                              {packagePricing?.isActive ? (
                                <label className="label label-success m-0">
                                  Active
                                </label>
                              ) : (
                                <label className="label label-danger m-0">
                                  Inactive
                                </label>
                              )}
                            </td>
                          </tr>
                          {packagePricing?.description && (
                            <tr>
                              <th>Description</th>
                              <td colSpan="3">{packagePricing.description}</td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </Card.Body>
                  </Card>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </>
  );
}

